import { render, staticRenderFns } from "./addforeignEmployess.vue?vue&type=template&id=9491308a&"
import script from "./addforeignEmployess.vue?vue&type=script&lang=js&"
export * from "./addforeignEmployess.vue?vue&type=script&lang=js&"
import style0 from "./addforeignEmployess.vue?vue&type=style&index=0&id=9491308a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports